import type { ReactNode } from 'react'
import { ScreenActionsEnabled } from './screenActionsContext'

// ONE OF A TAB'S VIEWS, KEPT MOUNTED WHILE ANOTHER SHOWS (owner, 2026-10-07:
// "Flipping between views at Rules > Routing and Rules > Companies and
// References > Other Requirements is not as smooth as References > Codes";
// Other Requirements has been Additional Detail since D-364).
//
// Codes is smooth because its three views are one mounted manager: all three
// lists load when the tab opens, the switch is a prop, and the table swaps in
// one paint. The other three tabs rendered one manager per view and unmounted
// the one you left, so every switch fetched again and showed the loading
// spinner in place of the list — about 100 to 200 ms with the list collapsed
// to the spinner's 32 px, then the new list. Every view of such a tab is now
// mounted when the tab opens and only hidden while another shows, so a switch
// is the same one-paint swap as Codes, with each list's own search, Status and
// selection still as left.
//
// A hidden view draws none of its header tools: `ScreenActions` reads
// `ScreenActionsEnabled`, so only the showing view's buttons are in the
// cluster. Its rows are as of its last load, the same as Codes' views.
export function KeptView({ active, children }: { active: boolean; children: ReactNode }) {
  return (
    <ScreenActionsEnabled.Provider value={active}>
      <div hidden={!active}>{children}</div>
    </ScreenActionsEnabled.Provider>
  )
}
